<template>
<div>
    <div class="pt-2 bg-destructive text-white text-sm" v-if="is_inaccessible">
        <div class="flex items-center justify-center">
            <div class="hidden md:inline-block">
                <img src="/images/mailman-says.svg" alt="Mailman Notice">
            </div>
            <p class="ml-3 mb-1">Mailman cannot access your Gmail inbox. You'll need to re-authorize. <a :href="`/reauth/${userId}`" class="underline"><strong>Re-authorize now</strong></a></p>
        </div>
    </div>  
    <div class="pt-2 bg-primary text-white text-sm" v-else-if="is_active">
        <div class="flex items-center justify-center">
            <div class="hidden md:inline-block">
                <img src="/images/mailman-says.svg" alt="Mailman Notice">
            </div>
            <p class="ml-3 mb-1">Delivering your mails at {{ schedule }}. <a href="/settings#delivery" class="underline"><strong>Change scheduling?</strong></a></p>
        </div>
    </div> 
</div>
</template>

<script>
export default {
    data() {
        return {
            has_custom_weekly_schedule: false,
            slots                     : [],
            is_active                 : false,
            is_inaccessible           : false,
        }
    },
    computed: {
        userId() {
            return window.User.id;
        },
        schedule() {
            return this.has_custom_weekly_schedule ? 'a custom weekly schedule' : this.slots.map(slot => slot.hour).join(', ');
        }
    },
    mounted() {
        Event.$on('mailbox:activated', this.refresh);

        Event.$on('mailbox:deactivated', this.hide);

        this.refresh();
    },
    methods: {
        refresh() {
            axios.get('/api/me')
            .then((response) => {
                const user = response.data.data;
                
                if (user.mailbox.is_active) {
                    this.show(user.mailbox);
                }
                this.is_inaccessible = user.is_inaccessible;
            })
            .catch((err) => {
                console.error(err);
            })
            .then(() => {
                this.loading = false;
            })
        },
        show(mailbox) {
            this.has_custom_weekly_schedule = mailbox.has_custom_weekly_schedule;
            this.slots                      = mailbox.slots;
            this.is_active                  = true;
        },
        hide() {
            this.is_active = false;
        }
    }
}
</script>